import { compareAsc } from 'date-fns';
import { Calendar } from 'primereact/calendar';
import { Dispatch, FC, SetStateAction, useEffect } from 'react';

interface Props {
  toDate: Date;
  setToDate: Dispatch<SetStateAction<Date>>;
  fromDate: Date;
  setFromDate: Dispatch<SetStateAction<Date>>;
  disabled?: boolean;
}

export const AssignmentSidebarDatesForm: FC<Props> = ({ toDate, setToDate, fromDate, setFromDate, disabled }) => {
  useEffect(() => {
    if (compareAsc(toDate, fromDate) === -1) {
      setToDate(new Date(fromDate.getTime() + 24 * 3600 * 1000));
    }
  }, [toDate, fromDate]);

  return (
    <div className="col-12 p-3 flex justify-content-between">
      <div className="col-5">
        <p className="font-semibold">Select when to display to students:</p>
        <Calendar
          inputStyle={{ borderRight: 'none', borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
          showIcon
          className="h-2rem w-full"
          minDate={new Date()}
          value={fromDate}
          disabled={disabled}
          onChange={e => setFromDate(e.target.value || fromDate)}
        />
      </div>
      <div className="col-5">
        <p className="font-semibold">Select due date:</p>
        <Calendar
          inputStyle={{ borderRight: 'none', borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
          showIcon
          className="h-2rem w-full"
          minDate={fromDate}
          value={toDate}
          disabled={disabled}
          onChange={date => setToDate(new Date(date.value!))}
        />
      </div>
    </div>
  );
};
